import { Box, HStack, Header, Switch, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const Wrapper = Box.withConfig({
  width: 'full',
  marginY: '$4',
});

export const Container = HStack.withConfig({
  borderRadius: '8px',
  marginY: '$0',
  marginX: '$4',
  padding: '$3',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderWidth: '1px',
  borderColor: Styles.shadowColor,
});

export const Content = Box;

export const Title = Header.withConfig({
  variant: 'headerThree',
  margin: '$0',
  color: Styles.color.tertiary,
});

export const PaymentMethod = HStack.withConfig({
  alignItems: 'center',
  marginY: '$1',
  marginX: '$0',
});

export const PaymentDetails = Text.withConfig({
  color: Styles.color.tertiary,
  margin: '$0',
  marginLeft: '$1',
});

export const StyledToggle = Switch.withConfig<{ newUI?: boolean }>(p => ({
  trackColor: {
    true: p.newUI ? Styles.color.validated : Styles.color.black,
    false: primitive.$blackOpacity30,
  },
}));

export const Action = Box;
